import React from 'react';
import { AlarmSeverity } from '../../types';

interface AlarmDotProps {
  severity: AlarmSeverity;
}

const colorMap: Record<AlarmSeverity, string> = {
  [AlarmSeverity.CRITICAL]: 'bg-danger',
  [AlarmSeverity.WARNING]: 'bg-warning',
  [AlarmSeverity.INFO]: 'bg-accent',
};

export default function AlarmDot({ severity }: AlarmDotProps) {
  const isPulse = severity === AlarmSeverity.CRITICAL;
  return (
    <span className="relative inline-flex h-2.5 w-2.5 flex-shrink-0 mt-1">
      {isPulse && (
        <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${colorMap[severity]} opacity-75`} />
      )}
      <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${colorMap[severity]}`} />
    </span>
  );
}
